import { env } from "./config";

export const DOCTOR_TATVA = process.env.REACT_APP_DOCTOR_TATVA;
export const VOICE_RX = process.env.REACT_APP_VOICE_RX;
export const VOICE_X_API_KEY = process.env.REACT_APP_VOICE_X_API_KEY;
export const TATVA_AI = process.env.REACT_APP_TATVA_AI;
export const MY_TATVA = process.env.REACT_APP_MY_TATVA;
export const DRLITE_SECRET_KEY = process.env.REACT_APP_DRLITE_SECRET_KEY;
export const ENC_KEY = process.env.REACT_APP_ENC_KEY;
export const ENC_IV = process.env.REACT_APP_ENC_IV;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const GENERAL_SPECIALITY_ID = env?.GENERAL_SPECIALITY_ID;
export const USER_MANAGEMENT = process.env.REACT_APP_USER_MANAGEMENT;
export const USER_MANAGEMENT_API_KEY =
  process.env.REACT_APP_USER_MANAGEMENT_API_KEY;
export const USER_MANAGEMENT_API_SECRET_KEY =
  process.env.REACT_APP_USER_MANAGEMENT_API_SECRET_KEY;
export const GOODFLIP_VITALS = process.env.REACT_APP_GOOD_FLIP_VITALS;
export const GOODFLIP_ACHIEVE = process.env.REACT_APP_GOOD_FLIP_ACHIEVE;
export const TATVA_PEDIA = process.env.REACT_APP_TATVA_PEDIA;
export const MKPLAYER_KEY = process.env.REACT_APP_MKPLAYER_KEY;
// MK.io streaming origin (same for UAT and prod); preconnected when a media page opens
export const MEDIAKIND_STREAMING_ORIGIN = "https://ep-mediaprod-mediaserviceprod.eastus.streaming.mediakind.com";
export const SOLR_API = process.env.REACT_APP_SOLR_API;
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;
export const APPOINTMENT_AGENT_WEBSOCKET_URL =
  process.env.REACT_APP_APPOINTMENT_AGENT_WEBSOCKET_URL;
export const EXTRACT_OPTIONS_URL = process.env.REACT_APP_EXTRACT_OPTIONS_URL;
export const CONVERSATION_ID_URL = process.env.REACT_APP_CONVERSATION_ID_URL;
export const APPOINTMENT_AGENT_RTC_URL =
  process.env.REACT_APP_APPOINTMENT_AGENT_RTC_URL;
export const EXTRACT_OPTIONS_COUNT = 3;
export const SYMPTOM_COLLECTOR_RTC_MODEL = "gpt-40-realtime-preview-2024-12-17";
export const SYMPTOM_COLLECTOR_TRANSCRIPTION_MODEL = "whisper-1";
export const APPOINTMENT_AGENT_RTC_MODEL = "gpt-4o-realtime-preview-2025-06-03";
export const TATVA_AI_BE = process.env.REACT_APP_TATVA_AI_BE;
export const TATVA_AI_BE_API_KEY = process.env.REACT_APP_TATVA_AI_BE_API_KEY;
export const TATVA_AI_BE_API_SECRET = process.env.REACT_APP_TATVA_AI_BE_API_SECRET;
export const TATVA_PRACTICE_WEBVIEW = process.env.REACT_APP_TATVA_PRACTICE_WEBVIEW;
export const APPOINTMENT_SECRET_KEY = process.env.REACT_APP_APPOINTMENT_SECRET_KEY;
export const SANP_AI_API_KEY = process.env.REACT_APP_SANP_AI_API_KEY;
export const PM_MASTER = process.env.REACT_APP_PM_MASTER;
